import { Platform } from 'react-native';

export { APP_STORE_URL, GOOGLE_PLAY_URL, MICROSOFT_STORE_URL } from '@/constants/appStoreLinks';

export function openStoreUrl(url) {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    // eslint-disable-next-line global-require
    const { Linking } = require('react-native');
    Linking.openURL(url);
  }
}
